import React from 'react';
import PropTypes from 'prop-types';

const Badge = ({text, color, className}) => {
  return (
    <p className={`badge s-cross-center s-main-center s-mb-0 smallest s-color-white small-radius s-px-4px ${color} ${className}`}>
      {text}
    </p>
  );
};

Badge.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
}

Badge.defaultProps = {
  color : 's-bg-blue',
  className: '',
}

export default Badge;
